/* eslint-disable camelcase */

// packages
import React from 'reactn'
import $ from 'jquery'

// atoms
import { Button, Container, Icon } from '../../atoms'

/**
 * Functional React component representing the footer.
 *
 * @class Footer
 * @author Lexus Drumgold <lex@lexusdrumgold.design>
 */
export default class Footer extends React.Component {
  constructor(props) {
    super(props)
    this.state = { menu_open: false, icon: 'bars', justify: null }
  }

  componentDidMount = () => {
    let { menu_open } = this.state

    let navigation = $('.adm-navigation')
    let icon = $('.ado-footer > .ada-container > .ada-button > .ada-icon')
    let footer_container = $('.ado-footer > .ada-container')

    this.setState({ justify: footer_container.css('justifyContent') })

    if (menu_open) {
      // show navigation
      navigation.addClass('open')
      icon.removeClass('fa-bars').addClass('fa-times')
    } else {
      // hide navigation
      navigation.removeClass('open')
      icon.removeClass('fa-times').addClass('fa-bars')
    }
  }

  handle_navigation = () => {
    let { menu_open, justify } = this.state
    let open = menu_open

    let navigation = $('.adm-navigation')
    let footer_container = $('.ado-footer > .ada-container')
    let icon = $('.ado-footer > .ada-container > .ada-button > .ada-icon')

    this.setState(state => ({
      menu_open: !open,
      icon: state.icon === 'bars' ? 'times' : 'bars'
    }))

    if (!menu_open) {
      // show navigation
      footer_container.css({ justifyContent: 'center' })
      navigation.addClass('open')
      icon.removeClass('fa-bars').addClass('fa-times')
    } else {
      // hide navigation
      navigation.removeClass('open')
      footer_container.css({ justifyContent: justify })
      icon.removeClass('fa-times').addClass('fa-bars')
    }

    this.forceUpdate()
  }

  /**
   * Renders the footer.
   *
   * @returns {HTMLElement} html footer element
   */
  render() {
    return (
      <footer className='ado-footer'>
        <Container>
          <Button onClick={() => this.handle_navigation()}>
            <Icon weight='fas' />
          </Button>
        </Container>
      </footer>
    )
  }
}
